import { useFormState } from '@graphcommerce/ecommerce-ui'
import { ApolloCartErrorSnackbar } from '@graphcommerce/magento-cart'
import {
  Button,
  ErrorSnackbar,
  ErrorSnackbarProps,
  filterNonNullableKeys,
  iconChevronRight,
  IconSvg,
  MessageSnackbar,
  MessageSnackbarProps,
} from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { toUserErrors } from '@graphcommerce/magento-product/components/AddProductsToCart/toUserErrors'
import { useFormAddProductsToCart } from '@graphcommerce/magento-product'
import { Snackbar } from '@mui/material'
import Image from 'next/image'
import IconCross from '../icons/IconCross'
import { useEffect, useState } from 'react'

export type AddProductsToCartSnackbarProps = {
  errorSnackbar?: Omit<ErrorSnackbarProps, 'open'>
  successSnackbar?: Omit<MessageSnackbarProps, 'action'>
}

export function AddProductsToCartSnackbar(props: AddProductsToCartSnackbarProps) {
  const { errorSnackbar, successSnackbar } = props
  const { error, data, redirect, control } = useFormAddProductsToCart()
  const formState = useFormState({ control })
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [close, setClose] = useState(false);


  const userErrors = toUserErrors(data)

  useEffect(() => {
    if (!close) {
      setShowSuccess(() => !formState.isSubmitting &&
        formState.isSubmitSuccessful &&
        !error?.message &&
        !userErrors.length &&
        !redirect
      )
    }
  }, [formState, error, userErrors, redirect]);



  const items = filterNonNullableKeys(data?.addProductsToCart?.cart.items)

  const showErrorSnackbar = userErrors.length > 0


  const handleHide = () => {
    setClose(true);
    setShowSuccess(false);
    successSnackbar?.onClose && successSnackbar?.onClose();
  }
  return (
    <>
      {error && <ApolloCartErrorSnackbar error={error} />}

      {showErrorSnackbar && (
        <Snackbar
          open={showSuccess}
          autoHideDuration={6000}
          onClose={handleHide}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <div className='flex relative max-w-[350px] justify-between items-center box-border border-error-500  rounded-sm border border-solid bg-white gap-3 p-3'>
            {data?.addProductsToCart?.user_errors?.map((e) => e?.message).join(', ')}

          </div>
        </Snackbar>

      )}

      {showSuccess && (
        <Snackbar
          open={showSuccess}
          autoHideDuration={6000}
          onClose={handleHide}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <div className='flex relative max-w-[350px] justify-between items-center box-border  rounded-sm border border-solid bg-white gap-3 p-3'>
            <Image width={60} height={60} alt='' src={items[items.length - 1]?.product.thumbnail?.url ?? ''} className='border border-solid w-16 h-16' />
            <p className='text-base font-medium text-light-400'>{`${items[items.length - 1]?.product.name} به سبد خریدتان افزوده شد.`}</p>

            <IconCross width={24} height={24} className='text-light-400 absolute top-1 left-1 cursor-pointer' onClick={handleHide} />
          </div>
        </Snackbar>
        /*   <MessageSnackbar
             variant='pill'
             {...successSnackbar}
             autoHide={false}
             open={showSuccess}
             classes={{}
             }
             action={
               <Button
                 href='/cart'
                 id='view-shopping-cart-button'
                 size='medium'
                 variant='pill'
                 color='secondary'
                 endIcon={<IconSvg src={iconChevronRight} />}
                 sx={{ display: 'flex' }}
               >
                 <Trans id='View shopping cart' />
               </Button>
             }
           >
             <Trans
               id='<0>{name}</0> has been added to your shopping cart!'
               components={{ 0: <strong /> }}
               values={{ name: items[items.length - 1]?.product.name }}
             />
           </MessageSnackbar>  */
      )}
    </>)
}
